import * as Types from '../graphqlBase.generated';

import { TypedDocumentString } from "~/gql/graphqlBase.generated";
import { baseApiWithGraphql } from '~/services/baseApi';
import type { GraphqlEndpointBuilder } from '~/services/baseApi';
export type GetPriceGroupQueryVariables = Types.Exact<{
  groupId: Types.Scalars['String']['input'];
}>;


export type GetPriceGroupQuery = { __typename?: 'Query', priceGroup?: { __typename?: 'PriceGroupStateData', id: string, derivedFromPriceGroupId?: string | null, derivedPercentOff?: number | null, isDefault: boolean, isManaged: boolean, name: string, status: Types.PricingStatus, tenantId: string, orderVolumeDiscount?: { __typename?: 'PriceGroupOrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, thresholdValue: number, value: number, valueType: Types.OrderVolumeDiscountValueType } | null, qualificationConditions?: { __typename?: 'PriceGroupQualificationConditionsData', orderByDate?: string | null, minLeadTimeDays?: number | null } | null, priceLevels: Array<{ __typename?: 'PriceLevelData', customerSellPrice?: number | null, endDate?: Types.TDateISO | null, growerCost?: number | null, growerSellPrice: number, kind: Types.PriceKind, levelType: Types.PriceLevelType, priceLevelId: string, quantityThreshold: number, startDate: Types.TDateISO, targetId: string, targetName: string, type: Types.TargetType, percentOff?: number | null, referencePriceGroupId?: string | null, volumePoolId?: string | null }> } | null };

export type GetPriceGroupMetaQueryVariables = Types.Exact<{
  groupId: Types.Scalars['String']['input'];
}>;


export type GetPriceGroupMetaQuery = { __typename?: 'Query', priceGroup?: { __typename?: 'PriceGroupStateData', id: string, derivedFromPriceGroupId?: string | null, derivedPercentOff?: number | null, isDefault: boolean, isManaged: boolean, name: string, status: Types.PricingStatus, tenantId: string, orderVolumeDiscount?: { __typename?: 'PriceGroupOrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, thresholdValue: number, value: number, valueType: Types.OrderVolumeDiscountValueType } | null, qualificationConditions?: { __typename?: 'PriceGroupQualificationConditionsData', orderByDate?: string | null, minLeadTimeDays?: number | null } | null } | null };

export type GetPriceLevelsBlockQueryVariables = Types.Exact<{
  priceGroupId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  offset: Types.Scalars['Int']['input'];
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  type?: Types.InputMaybe<Types.TargetType>;
  types?: Types.InputMaybe<Array<Types.TargetType> | Types.TargetType>;
  targetId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  targetNameSearch?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sort?: Types.InputMaybe<Array<Types.PriceLevelSortInput> | Types.PriceLevelSortInput>;
}>;


export type GetPriceLevelsBlockQuery = { __typename?: 'Query', priceLevelsBlock: { __typename?: 'PriceLevelsBlockPayload', totalCount: number, nodes: Array<{ __typename?: 'PriceLevelDocument', id: string, priceGroupId: string, priceLevelId: string, type: Types.TargetType, levelType: Types.PriceLevelType, targetId: string, targetName: string, quantityThreshold: number, growerCost?: number | null, growerSellPrice: number, customerSellPrice?: number | null, startDate: Types.TDateISO, endDate?: Types.TDateISO | null, kind: Types.PriceKind, percentOff?: number | null, referencePriceGroupId?: string | null, volumePoolId?: string | null, volumePool?: { __typename?: 'VolumePool', id: string, volumePoolId: string, code: string, name: string, quantityBasis: Types.QuantityBasis, status: Types.VolumePoolStatus, retiredAt?: Types.TDateISO | null } | null }> } };

export type GetPriceLevelsQueryVariables = Types.Exact<{
  priceGroupId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  where?: Types.InputMaybe<Types.PriceLevelDocumentFilterInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type GetPriceLevelsQuery = { __typename?: 'Query', priceLevels?: { __typename?: 'PriceLevelsConnection', totalCount: number, nodes?: Array<{ __typename?: 'PriceLevelDocument', id: string, priceGroupId: string, priceLevelId: string, type: Types.TargetType, levelType: Types.PriceLevelType, targetId: string, targetName: string, quantityThreshold: number, growerCost?: number | null, growerSellPrice: number, customerSellPrice?: number | null, startDate: Types.TDateISO, endDate?: Types.TDateISO | null, kind: Types.PriceKind, percentOff?: number | null, referencePriceGroupId?: string | null, volumePoolId?: string | null, volumePool?: { __typename?: 'VolumePool', id: string, volumePoolId: string, code: string, name: string, quantityBasis: Types.QuantityBasis, status: Types.VolumePoolStatus, retiredAt?: Types.TDateISO | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetPriceGroupsQueryVariables = Types.Exact<{
  where?: Types.InputMaybe<Types.PriceGroupDocumentFilterInput>;
  order?: Types.InputMaybe<Array<Types.PriceGroupDocumentSortInput> | Types.PriceGroupDocumentSortInput>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type GetPriceGroupsQuery = { __typename?: 'Query', priceGroups?: { __typename?: 'PriceGroupsConnection', totalCount: number, nodes?: Array<{ __typename?: 'PriceGroupDocument', id: string, derivedFromPriceGroupId?: string | null, derivedPercentOff?: number | null, isDefault: boolean, isManaged: boolean, name: string, numberOfLevels: number, priceId: string, status: Types.PricingStatus, tenantId: string, usageCount?: number | null, qualificationConditions?: { __typename?: 'PriceGroupQualificationConditionsDocument', orderByDate?: string | null, minLeadTimeDays?: number | null } | null }> | null, pageInfo: { __typename?: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type GetItemPriceQueryVariables = Types.Exact<{
  itemId: Types.Scalars['String']['input'];
  locationId: Types.Scalars['UUID']['input'];
  orderDate?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  quantity: Types.Scalars['Int']['input'];
}>;


export type GetItemPriceQuery = { __typename?: 'Query', itemPrice: number };

export type GetItemPriceLevelsQueryVariables = Types.Exact<{
  itemId: Types.Scalars['String']['input'];
}>;


export type GetItemPriceLevelsQuery = { __typename?: 'Query', itemPriceLevels: Array<{ __typename?: 'ItemPriceLevelRow', priceGroupId: string, priceGroupName: string, priceLevelId: string, type: Types.TargetType, targetId: string, targetName: string, quantityThreshold: number, growerCost?: number | null, growerSellPrice: number, customerSellPrice?: number | null, startDate: Types.TDateISO, endDate?: Types.TDateISO | null, kind: Types.PriceKind, percentOff?: number | null, referencePriceGroupId?: string | null, volumePoolId?: string | null, volumePool?: { __typename?: 'VolumePool', id: string, volumePoolId: string, code: string, name: string, quantityBasis: Types.QuantityBasis, status: Types.VolumePoolStatus, retiredAt?: Types.TDateISO | null } | null }> };

export type GetCategoryVolumeCoverageQueryVariables = Types.Exact<{
  categoryCode: Types.Scalars['String']['input'];
  priceGroupId: Types.Scalars['String']['input'];
}>;


export type GetCategoryVolumeCoverageQuery = { __typename?: 'Query', categoryVolumeCoverage: { __typename?: 'CategoryVolumeCoverage', categoryCode: string, priceGroupId: string, totalActiveItems: number, itemsWithOwnPriceLevel: number } };

export type GetItemPriceExplanationQueryVariables = Types.Exact<{
  itemId: Types.Scalars['String']['input'];
  locationId: Types.Scalars['UUID']['input'];
  orderDate?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  quantity: Types.Scalars['Int']['input'];
  orderPlacedDate?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  eachesQuantity?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  orderId?: Types.InputMaybe<Types.Scalars['String']['input']>;
  lineItemId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
}>;


export type GetItemPriceExplanationQuery = { __typename?: 'Query', itemPriceExplanation: { __typename?: 'ItemPriceExplanation', finalPrice: number, outcome: Types.PriceResolutionOutcome, error?: string | null, winningLevelId?: string | null, unitPriceExact: number, unitPriceDecimals: number, pooledQuantity?: number | null, unpooledReason?: Types.UnpooledReason | null, priceGroup?: { __typename?: 'ResolvedPriceGroup', priceGroupId: string, name: string, source: Types.PriceGroupSource } | null, candidateLevels: Array<{ __typename?: 'ExplainedLevel', priceLevelId: string, targetId: string, targetName: string, type: Types.TargetType, levelType: Types.PriceLevelType, status: Types.LevelStatus, quantityThreshold: number, growerSellPrice: number, customerSellPrice?: number | null, startDate: Types.TDateISO, endDate?: Types.TDateISO | null }>, siblingLevels: Array<{ __typename?: 'ExplainedLevel', priceLevelId: string, targetId: string, targetName: string, type: Types.TargetType, levelType: Types.PriceLevelType, status: Types.LevelStatus, quantityThreshold: number, growerSellPrice: number, customerSellPrice?: number | null, startDate: Types.TDateISO, endDate?: Types.TDateISO | null }>, derivation?: { __typename?: 'DerivedPriceExplanation', referencePriceGroupId: string, referencePriceGroupName: string, referenceWinningLevelId?: string | null, percentOff: number, derivedPrice: number } | null, skippedPriceGroups: Array<{ __typename?: 'SkippedPriceGroupExplanation', priceGroupId: string, name: string, reason: Types.PriceGroupQualificationSkipReason, configuredOrderByDate?: string | null, configuredMinLeadTimeDays?: number | null, orderPlacedBusinessDay?: string | null, requestedShipDay?: string | null, leadTimeDays?: number | null }>, qualificationConditions?: { __typename?: 'ExplainedQualificationConditions', orderByDate?: string | null, minLeadTimeDays?: number | null } | null, lineBasis: { __typename?: 'ExplainedLineBasis', quantity: number, eachesQuantity?: number | null, quantityBasis: number }, pool?: { __typename?: 'VolumePool', id: string, volumePoolId: string, code: string, name: string, quantityBasis: Types.QuantityBasis, status: Types.VolumePoolStatus, retiredAt?: Types.TDateISO | null } | null, rungChosen?: { __typename?: 'ExplainedRung', priceLevelId: string, quantityThreshold: number, price: number } | null } };

export type GetOrderLinePricePreviewQueryVariables = Types.Exact<{
  input: Types.OrderLinePricePreviewInput;
}>;


export type GetOrderLinePricePreviewQuery = { __typename?: 'Query', orderLinePricePreview: { __typename?: 'OrderLinePricePreview', state: Types.OrderLinePricePreviewState, reason?: string | null, stagedLineId: string, controllerGeneration: number, operation?: Types.OrderLinePricePreviewOperation | null, suggestedPrice?: number | null, manualPrice?: number | null, committedPrice?: number | null, refusedStage?: string | null, siblingPricesChange: boolean, resolvedAt: Types.TDateISO, physicalTarget?: { __typename?: 'OrderLinePricePreviewPhysicalTarget', lineNumber: number, lineItemId: string, mergedIntoExisting: boolean } | null, source?: { __typename?: 'OrderLinePricePreviewSource', receiverMode: Types.OrderLinePricePreviewReceiverMode, priceGroupId?: string | null, priceLevelId?: string | null, volumePoolId?: string | null, pooledQuantity?: number | null, levelEffectiveAt: Types.TDateISO, placedDate?: Types.TDateISO | null, requestedShipDate?: Types.TDateISO | null } | null, mode?: { __typename?: 'OrderLinePricePreviewMode', planVersion: number, serverPricedAdds: boolean, erpPricing: boolean, entityKind: Types.OrderLinePricePreviewEntityKind, receiver: Types.OrderLinePricePreviewReceiver, fingerprint: string } | null } };

export type GetNewOrderLinePricesQueryVariables = Types.Exact<{
  orders: Array<Types.NewOrderPricingDataInput> | Types.NewOrderPricingDataInput;
}>;


export type GetNewOrderLinePricesQuery = { __typename?: 'Query', pricesForNewOrderLines: Array<{ __typename?: 'NewOrderPrices', lines: Array<{ __typename?: 'NewOrderLinePrice', key: string, unitPrice?: number | null }> }> };

export type ExplainedRungFragment = { __typename?: 'ExplainedRung', priceLevelId: string, quantityThreshold: number, price: number };

export type SkippedPriceGroupExplanationFragment = { __typename?: 'SkippedPriceGroupExplanation', priceGroupId: string, name: string, reason: Types.PriceGroupQualificationSkipReason, configuredOrderByDate?: string | null, configuredMinLeadTimeDays?: number | null, orderPlacedBusinessDay?: string | null, requestedShipDay?: string | null, leadTimeDays?: number | null };

export type ExplainedQualificationConditionsFragment = { __typename?: 'ExplainedQualificationConditions', orderByDate?: string | null, minLeadTimeDays?: number | null };

export type ExplainedLineBasisFragment = { __typename?: 'ExplainedLineBasis', quantity: number, eachesQuantity?: number | null, quantityBasis: number };

export type PriceGroupDocumentFragment = { __typename?: 'PriceGroupDocument', id: string, derivedFromPriceGroupId?: string | null, derivedPercentOff?: number | null, isDefault: boolean, isManaged: boolean, name: string, numberOfLevels: number, priceId: string, status: Types.PricingStatus, tenantId: string, usageCount?: number | null, qualificationConditions?: { __typename?: 'PriceGroupQualificationConditionsDocument', orderByDate?: string | null, minLeadTimeDays?: number | null } | null };

export type DerivedPriceExplanationFragment = { __typename?: 'DerivedPriceExplanation', referencePriceGroupId: string, referencePriceGroupName: string, referenceWinningLevelId?: string | null, percentOff: number, derivedPrice: number };

export type PriceLevelDocumentFragment = { __typename?: 'PriceLevelDocument', id: string, priceGroupId: string, priceLevelId: string, type: Types.TargetType, levelType: Types.PriceLevelType, targetId: string, targetName: string, quantityThreshold: number, growerCost?: number | null, growerSellPrice: number, customerSellPrice?: number | null, startDate: Types.TDateISO, endDate?: Types.TDateISO | null, kind: Types.PriceKind, percentOff?: number | null, referencePriceGroupId?: string | null, volumePoolId?: string | null, volumePool?: { __typename?: 'VolumePool', id: string, volumePoolId: string, code: string, name: string, quantityBasis: Types.QuantityBasis, status: Types.VolumePoolStatus, retiredAt?: Types.TDateISO | null } | null };

export type AdjustedPriceLevelFragment = { __typename?: 'AdjustedPriceLevelData', priceLevelId: string, successorPriceLevelId: string, field: Types.PriceLevelPriceField, oldPrice?: number | null, newPrice?: number | null };

export type ExplainedLevelFragment = { __typename?: 'ExplainedLevel', priceLevelId: string, targetId: string, targetName: string, type: Types.TargetType, levelType: Types.PriceLevelType, status: Types.LevelStatus, quantityThreshold: number, growerSellPrice: number, customerSellPrice?: number | null, startDate: Types.TDateISO, endDate?: Types.TDateISO | null };

export type PriceGroupOrderVolumeDiscountFragment = { __typename?: 'PriceGroupOrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, thresholdValue: number, value: number, valueType: Types.OrderVolumeDiscountValueType };

export type PriceGroupQualificationConditionsFragment = { __typename?: 'PriceGroupQualificationConditionsData', orderByDate?: string | null, minLeadTimeDays?: number | null };

export type PriceGroupQualificationConditionsDocumentFragment = { __typename?: 'PriceGroupQualificationConditionsDocument', orderByDate?: string | null, minLeadTimeDays?: number | null };

export type PriceGroupStateDataFragment = { __typename?: 'PriceGroupStateData', id: string, derivedFromPriceGroupId?: string | null, derivedPercentOff?: number | null, isDefault: boolean, isManaged: boolean, name: string, status: Types.PricingStatus, tenantId: string, orderVolumeDiscount?: { __typename?: 'PriceGroupOrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, thresholdValue: number, value: number, valueType: Types.OrderVolumeDiscountValueType } | null, qualificationConditions?: { __typename?: 'PriceGroupQualificationConditionsData', orderByDate?: string | null, minLeadTimeDays?: number | null } | null, priceLevels: Array<{ __typename?: 'PriceLevelData', customerSellPrice?: number | null, endDate?: Types.TDateISO | null, growerCost?: number | null, growerSellPrice: number, kind: Types.PriceKind, levelType: Types.PriceLevelType, priceLevelId: string, quantityThreshold: number, startDate: Types.TDateISO, targetId: string, targetName: string, type: Types.TargetType, percentOff?: number | null, referencePriceGroupId?: string | null, volumePoolId?: string | null }> };

export type PriceGroupMetaDataFragment = { __typename?: 'PriceGroupStateData', id: string, derivedFromPriceGroupId?: string | null, derivedPercentOff?: number | null, isDefault: boolean, isManaged: boolean, name: string, status: Types.PricingStatus, tenantId: string, orderVolumeDiscount?: { __typename?: 'PriceGroupOrderVolumeDiscountData', thresholdType: Types.OrderVolumeThresholdType, thresholdValue: number, value: number, valueType: Types.OrderVolumeDiscountValueType } | null, qualificationConditions?: { __typename?: 'PriceGroupQualificationConditionsData', orderByDate?: string | null, minLeadTimeDays?: number | null } | null };

export const ExplainedRungFragmentDoc = new TypedDocumentString(`
    fragment ExplainedRung on ExplainedRung {
  priceLevelId
  quantityThreshold
  price
}
    `, {"fragmentName":"ExplainedRung"});
export const SkippedPriceGroupExplanationFragmentDoc = new TypedDocumentString(`
    fragment SkippedPriceGroupExplanation on SkippedPriceGroupExplanation {
  priceGroupId
  name
  reason
  configuredOrderByDate
  configuredMinLeadTimeDays
  orderPlacedBusinessDay
  requestedShipDay
  leadTimeDays
}
    `, {"fragmentName":"SkippedPriceGroupExplanation"});
export const ExplainedQualificationConditionsFragmentDoc = new TypedDocumentString(`
    fragment ExplainedQualificationConditions on ExplainedQualificationConditions {
  orderByDate
  minLeadTimeDays
}
    `, {"fragmentName":"ExplainedQualificationConditions"});
export const ExplainedLineBasisFragmentDoc = new TypedDocumentString(`
    fragment ExplainedLineBasis on ExplainedLineBasis {
  quantity
  eachesQuantity
  quantityBasis
}
    `, {"fragmentName":"ExplainedLineBasis"});
export const PriceGroupQualificationConditionsDocumentFragmentDoc = new TypedDocumentString(`
    fragment PriceGroupQualificationConditionsDocument on PriceGroupQualificationConditionsDocument {
  orderByDate
  minLeadTimeDays
}
    `, {"fragmentName":"PriceGroupQualificationConditionsDocument"});
export const PriceGroupDocumentFragmentDoc = new TypedDocumentString(`
    fragment PriceGroupDocument on PriceGroupDocument {
  id
  derivedFromPriceGroupId
  derivedPercentOff
  isDefault
  isManaged
  name
  numberOfLevels
  priceId
  qualificationConditions {
    ...PriceGroupQualificationConditionsDocument
  }
  status
  tenantId
  usageCount
}
    fragment PriceGroupQualificationConditionsDocument on PriceGroupQualificationConditionsDocument {
  orderByDate
  minLeadTimeDays
}`, {"fragmentName":"PriceGroupDocument"});
export const DerivedPriceExplanationFragmentDoc = new TypedDocumentString(`
    fragment DerivedPriceExplanation on DerivedPriceExplanation {
  referencePriceGroupId
  referencePriceGroupName
  referenceWinningLevelId
  percentOff
  derivedPrice
}
    `, {"fragmentName":"DerivedPriceExplanation"});
export const PriceLevelDocumentFragmentDoc = new TypedDocumentString(`
    fragment PriceLevelDocument on PriceLevelDocument {
  id
  priceGroupId
  priceLevelId
  type
  levelType
  targetId
  targetName
  quantityThreshold
  growerCost
  growerSellPrice
  customerSellPrice
  startDate
  endDate
  kind
  percentOff
  referencePriceGroupId
  volumePoolId
  volumePool {
    ...VolumePool
  }
}
    fragment VolumePool on VolumePool {
  id
  volumePoolId
  code
  name
  quantityBasis
  status
  retiredAt
}`, {"fragmentName":"PriceLevelDocument"});
export const AdjustedPriceLevelFragmentDoc = new TypedDocumentString(`
    fragment AdjustedPriceLevel on AdjustedPriceLevelData {
  priceLevelId
  successorPriceLevelId
  field
  oldPrice
  newPrice
}
    `, {"fragmentName":"AdjustedPriceLevel"});
export const ExplainedLevelFragmentDoc = new TypedDocumentString(`
    fragment ExplainedLevel on ExplainedLevel {
  priceLevelId
  targetId
  targetName
  type
  levelType
  status
  quantityThreshold
  growerSellPrice
  customerSellPrice
  startDate
  endDate
}
    `, {"fragmentName":"ExplainedLevel"});
export const PriceGroupOrderVolumeDiscountFragmentDoc = new TypedDocumentString(`
    fragment PriceGroupOrderVolumeDiscount on PriceGroupOrderVolumeDiscountData {
  thresholdType
  thresholdValue
  value
  valueType
}
    `, {"fragmentName":"PriceGroupOrderVolumeDiscount"});
export const PriceGroupQualificationConditionsFragmentDoc = new TypedDocumentString(`
    fragment PriceGroupQualificationConditions on PriceGroupQualificationConditionsData {
  orderByDate
  minLeadTimeDays
}
    `, {"fragmentName":"PriceGroupQualificationConditions"});
export const PriceGroupStateDataFragmentDoc = new TypedDocumentString(`
    fragment PriceGroupStateData on PriceGroupStateData {
  id
  derivedFromPriceGroupId
  derivedPercentOff
  isDefault
  isManaged
  name
  orderVolumeDiscount {
    ...PriceGroupOrderVolumeDiscount
  }
  qualificationConditions {
    ...PriceGroupQualificationConditions
  }
  priceLevels {
    customerSellPrice
    endDate
    growerCost
    growerSellPrice
    kind
    levelType
    priceLevelId
    quantityThreshold
    startDate
    targetId
    targetName
    type
    kind
    percentOff
    referencePriceGroupId
    volumePoolId
  }
  status
  tenantId
}
    fragment PriceGroupOrderVolumeDiscount on PriceGroupOrderVolumeDiscountData {
  thresholdType
  thresholdValue
  value
  valueType
}
fragment PriceGroupQualificationConditions on PriceGroupQualificationConditionsData {
  orderByDate
  minLeadTimeDays
}`, {"fragmentName":"PriceGroupStateData"});
export const PriceGroupMetaDataFragmentDoc = new TypedDocumentString(`
    fragment PriceGroupMetaData on PriceGroupStateData {
  id
  derivedFromPriceGroupId
  derivedPercentOff
  isDefault
  isManaged
  name
  orderVolumeDiscount {
    ...PriceGroupOrderVolumeDiscount
  }
  qualificationConditions {
    ...PriceGroupQualificationConditions
  }
  status
  tenantId
}
    fragment PriceGroupOrderVolumeDiscount on PriceGroupOrderVolumeDiscountData {
  thresholdType
  thresholdValue
  value
  valueType
}
fragment PriceGroupQualificationConditions on PriceGroupQualificationConditionsData {
  orderByDate
  minLeadTimeDays
}`, {"fragmentName":"PriceGroupMetaData"});
export const GetPriceGroupDocument = new TypedDocumentString(`
    query GetPriceGroup($groupId: String!) {
  priceGroup(groupId: $groupId) {
    ...PriceGroupStateData
  }
}
    fragment PriceGroupOrderVolumeDiscount on PriceGroupOrderVolumeDiscountData {
  thresholdType
  thresholdValue
  value
  valueType
}
fragment PriceGroupQualificationConditions on PriceGroupQualificationConditionsData {
  orderByDate
  minLeadTimeDays
}
fragment PriceGroupStateData on PriceGroupStateData {
  id
  derivedFromPriceGroupId
  derivedPercentOff
  isDefault
  isManaged
  name
  orderVolumeDiscount {
    ...PriceGroupOrderVolumeDiscount
  }
  qualificationConditions {
    ...PriceGroupQualificationConditions
  }
  priceLevels {
    customerSellPrice
    endDate
    growerCost
    growerSellPrice
    kind
    levelType
    priceLevelId
    quantityThreshold
    startDate
    targetId
    targetName
    type
    kind
    percentOff
    referencePriceGroupId
    volumePoolId
  }
  status
  tenantId
}`);
export const GetPriceGroupMetaDocument = new TypedDocumentString(`
    query GetPriceGroupMeta($groupId: String!) {
  priceGroup(groupId: $groupId) {
    ...PriceGroupMetaData
  }
}
    fragment PriceGroupOrderVolumeDiscount on PriceGroupOrderVolumeDiscountData {
  thresholdType
  thresholdValue
  value
  valueType
}
fragment PriceGroupQualificationConditions on PriceGroupQualificationConditionsData {
  orderByDate
  minLeadTimeDays
}
fragment PriceGroupMetaData on PriceGroupStateData {
  id
  derivedFromPriceGroupId
  derivedPercentOff
  isDefault
  isManaged
  name
  orderVolumeDiscount {
    ...PriceGroupOrderVolumeDiscount
  }
  qualificationConditions {
    ...PriceGroupQualificationConditions
  }
  status
  tenantId
}`);
export const GetPriceLevelsBlockDocument = new TypedDocumentString(`
    query GetPriceLevelsBlock($priceGroupId: String, $offset: Int!, $limit: Int, $type: TargetType, $types: [TargetType!], $targetId: String, $targetNameSearch: String, $sort: [PriceLevelSortInput!]) {
  priceLevelsBlock(
    priceGroupId: $priceGroupId
    offset: $offset
    limit: $limit
    type: $type
    types: $types
    targetId: $targetId
    targetNameSearch: $targetNameSearch
    sort: $sort
  ) {
    nodes {
      ...PriceLevelDocument
    }
    totalCount
  }
}
    fragment PriceLevelDocument on PriceLevelDocument {
  id
  priceGroupId
  priceLevelId
  type
  levelType
  targetId
  targetName
  quantityThreshold
  growerCost
  growerSellPrice
  customerSellPrice
  startDate
  endDate
  kind
  percentOff
  referencePriceGroupId
  volumePoolId
  volumePool {
    ...VolumePool
  }
}
fragment VolumePool on VolumePool {
  id
  volumePoolId
  code
  name
  quantityBasis
  status
  retiredAt
}`);
export const GetPriceLevelsDocument = new TypedDocumentString(`
    query GetPriceLevels($priceGroupId: String, $where: PriceLevelDocumentFilterInput, $first: Int) {
  priceLevels(priceGroupId: $priceGroupId, where: $where, first: $first) {
    nodes {
      ...PriceLevelDocument
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PriceLevelDocument on PriceLevelDocument {
  id
  priceGroupId
  priceLevelId
  type
  levelType
  targetId
  targetName
  quantityThreshold
  growerCost
  growerSellPrice
  customerSellPrice
  startDate
  endDate
  kind
  percentOff
  referencePriceGroupId
  volumePoolId
  volumePool {
    ...VolumePool
  }
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}
fragment VolumePool on VolumePool {
  id
  volumePoolId
  code
  name
  quantityBasis
  status
  retiredAt
}`);
export const GetPriceGroupsDocument = new TypedDocumentString(`
    query GetPriceGroups($where: PriceGroupDocumentFilterInput, $order: [PriceGroupDocumentSortInput!], $first: Int, $after: String, $last: Int, $before: String) {
  priceGroups(
    where: $where
    order: $order
    first: $first
    after: $after
    last: $last
    before: $before
  ) {
    nodes {
      ...PriceGroupDocument
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment PriceGroupDocument on PriceGroupDocument {
  id
  derivedFromPriceGroupId
  derivedPercentOff
  isDefault
  isManaged
  name
  numberOfLevels
  priceId
  qualificationConditions {
    ...PriceGroupQualificationConditionsDocument
  }
  status
  tenantId
  usageCount
}
fragment PriceGroupQualificationConditionsDocument on PriceGroupQualificationConditionsDocument {
  orderByDate
  minLeadTimeDays
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);
export const GetItemPriceDocument = new TypedDocumentString(`
    query GetItemPrice($itemId: String!, $locationId: UUID!, $orderDate: DateTime, $quantity: Int!) {
  itemPrice(
    itemId: $itemId
    locationId: $locationId
    orderDate: $orderDate
    quantity: $quantity
  )
}
    `);
export const GetItemPriceLevelsDocument = new TypedDocumentString(`
    query GetItemPriceLevels($itemId: String!) {
  itemPriceLevels(itemId: $itemId) {
    priceGroupId
    priceGroupName
    priceLevelId
    type
    targetId
    targetName
    quantityThreshold
    growerCost
    growerSellPrice
    customerSellPrice
    startDate
    endDate
    kind
    percentOff
    referencePriceGroupId
    volumePoolId
    volumePool {
      ...VolumePool
    }
  }
}
    fragment VolumePool on VolumePool {
  id
  volumePoolId
  code
  name
  quantityBasis
  status
  retiredAt
}`);
export const GetCategoryVolumeCoverageDocument = new TypedDocumentString(`
    query GetCategoryVolumeCoverage($categoryCode: String!, $priceGroupId: String!) {
  categoryVolumeCoverage(categoryCode: $categoryCode, priceGroupId: $priceGroupId) {
    categoryCode
    priceGroupId
    totalActiveItems
    itemsWithOwnPriceLevel
  }
}
    `);
export const GetItemPriceExplanationDocument = new TypedDocumentString(`
    query GetItemPriceExplanation($itemId: String!, $locationId: UUID!, $orderDate: DateTime, $quantity: Int!, $orderPlacedDate: DateTime, $eachesQuantity: Int, $orderId: String, $lineItemId: UUID) {
  itemPriceExplanation(
    itemId: $itemId
    locationId: $locationId
    orderDate: $orderDate
    quantity: $quantity
    orderPlacedDate: $orderPlacedDate
    eachesQuantity: $eachesQuantity
    orderId: $orderId
    lineItemId: $lineItemId
  ) {
    finalPrice
    outcome
    error
    winningLevelId
    priceGroup {
      priceGroupId
      name
      source
    }
    candidateLevels {
      ...ExplainedLevel
    }
    siblingLevels {
      ...ExplainedLevel
    }
    derivation {
      ...DerivedPriceExplanation
    }
    skippedPriceGroups {
      ...SkippedPriceGroupExplanation
    }
    qualificationConditions {
      ...ExplainedQualificationConditions
    }
    unitPriceExact
    unitPriceDecimals
    lineBasis {
      ...ExplainedLineBasis
    }
    pool {
      ...VolumePool
    }
    pooledQuantity
    rungChosen {
      ...ExplainedRung
    }
    unpooledReason
  }
}
    fragment ExplainedRung on ExplainedRung {
  priceLevelId
  quantityThreshold
  price
}
fragment SkippedPriceGroupExplanation on SkippedPriceGroupExplanation {
  priceGroupId
  name
  reason
  configuredOrderByDate
  configuredMinLeadTimeDays
  orderPlacedBusinessDay
  requestedShipDay
  leadTimeDays
}
fragment ExplainedQualificationConditions on ExplainedQualificationConditions {
  orderByDate
  minLeadTimeDays
}
fragment ExplainedLineBasis on ExplainedLineBasis {
  quantity
  eachesQuantity
  quantityBasis
}
fragment DerivedPriceExplanation on DerivedPriceExplanation {
  referencePriceGroupId
  referencePriceGroupName
  referenceWinningLevelId
  percentOff
  derivedPrice
}
fragment ExplainedLevel on ExplainedLevel {
  priceLevelId
  targetId
  targetName
  type
  levelType
  status
  quantityThreshold
  growerSellPrice
  customerSellPrice
  startDate
  endDate
}
fragment VolumePool on VolumePool {
  id
  volumePoolId
  code
  name
  quantityBasis
  status
  retiredAt
}`);
export const GetOrderLinePricePreviewDocument = new TypedDocumentString(`
    query GetOrderLinePricePreview($input: OrderLinePricePreviewInput!) {
  orderLinePricePreview(input: $input) {
    state
    reason
    stagedLineId
    controllerGeneration
    operation
    suggestedPrice
    manualPrice
    committedPrice
    physicalTarget {
      lineNumber
      lineItemId
      mergedIntoExisting
    }
    source {
      receiverMode
      priceGroupId
      priceLevelId
      volumePoolId
      pooledQuantity
      levelEffectiveAt
      placedDate
      requestedShipDate
    }
    mode {
      planVersion
      serverPricedAdds
      erpPricing
      entityKind
      receiver
      fingerprint
    }
    refusedStage
    siblingPricesChange
    resolvedAt
  }
}
    `);
export const GetNewOrderLinePricesDocument = new TypedDocumentString(`
    query GetNewOrderLinePrices($orders: [NewOrderPricingDataInput!]!) {
  pricesForNewOrderLines(orders: $orders) {
    lines {
      key
      unitPrice
    }
  }
}
    `);
const injectedRtkApiEndpoints = (build: GraphqlEndpointBuilder) => ({
    GetPriceGroup: build.query<GetPriceGroupQuery, GetPriceGroupQueryVariables>({
      query: (variables) => ({ document: GetPriceGroupDocument, variables })
    }),
    GetPriceGroupMeta: build.query<GetPriceGroupMetaQuery, GetPriceGroupMetaQueryVariables>({
      query: (variables) => ({ document: GetPriceGroupMetaDocument, variables })
    }),
    GetPriceLevelsBlock: build.query<GetPriceLevelsBlockQuery, GetPriceLevelsBlockQueryVariables>({
      query: (variables) => ({ document: GetPriceLevelsBlockDocument, variables })
    }),
    GetPriceLevels: build.query<GetPriceLevelsQuery, GetPriceLevelsQueryVariables | void>({
      query: (variables) => ({ document: GetPriceLevelsDocument, variables })
    }),
    GetPriceGroups: build.query<GetPriceGroupsQuery, GetPriceGroupsQueryVariables | void>({
      query: (variables) => ({ document: GetPriceGroupsDocument, variables })
    }),
    GetItemPrice: build.query<GetItemPriceQuery, GetItemPriceQueryVariables>({
      query: (variables) => ({ document: GetItemPriceDocument, variables })
    }),
    GetItemPriceLevels: build.query<GetItemPriceLevelsQuery, GetItemPriceLevelsQueryVariables>({
      query: (variables) => ({ document: GetItemPriceLevelsDocument, variables })
    }),
    GetCategoryVolumeCoverage: build.query<GetCategoryVolumeCoverageQuery, GetCategoryVolumeCoverageQueryVariables>({
      query: (variables) => ({ document: GetCategoryVolumeCoverageDocument, variables })
    }),
    GetItemPriceExplanation: build.query<GetItemPriceExplanationQuery, GetItemPriceExplanationQueryVariables>({
      query: (variables) => ({ document: GetItemPriceExplanationDocument, variables })
    }),
    GetOrderLinePricePreview: build.query<GetOrderLinePricePreviewQuery, GetOrderLinePricePreviewQueryVariables>({
      query: (variables) => ({ document: GetOrderLinePricePreviewDocument, variables })
    }),
    GetNewOrderLinePrices: build.query<GetNewOrderLinePricesQuery, GetNewOrderLinePricesQueryVariables>({
      query: (variables) => ({ document: GetNewOrderLinePricesDocument, variables })
    }),
});

const injectedRtkApi = baseApiWithGraphql.injectEndpoints({ endpoints: injectedRtkApiEndpoints });

export type GeneratedEndpointDefinitions = ReturnType<typeof injectedRtkApiEndpoints>;

export { injectedRtkApi as api };
export const { useGetPriceGroupQuery, useLazyGetPriceGroupQuery, useGetPriceGroupMetaQuery, useLazyGetPriceGroupMetaQuery, useGetPriceLevelsBlockQuery, useLazyGetPriceLevelsBlockQuery, useGetPriceLevelsQuery, useLazyGetPriceLevelsQuery, useGetPriceGroupsQuery, useLazyGetPriceGroupsQuery, useGetItemPriceQuery, useLazyGetItemPriceQuery, useGetItemPriceLevelsQuery, useLazyGetItemPriceLevelsQuery, useGetCategoryVolumeCoverageQuery, useLazyGetCategoryVolumeCoverageQuery, useGetItemPriceExplanationQuery, useLazyGetItemPriceExplanationQuery, useGetOrderLinePricePreviewQuery, useLazyGetOrderLinePricePreviewQuery, useGetNewOrderLinePricesQuery, useLazyGetNewOrderLinePricesQuery } = injectedRtkApi;
